import axios from 'axios';

export enum ELeiMigraceStav {
    MUJDEPOZITAR = 'MUJDEPOZITAR',
    LEIPORTAL = 'LEIPORTAL',
    NEEXISTUJE = 'NEEXISTUJE'
}

export interface ILeiMigraceUcet {
    email: string;
    stav: ELeiMigraceStav;
}

export interface ILeiLoginResp {
    stav: 'LZE' | 'NELZE';
    lei: string;
    spolecnost: string;
    ucty: ILeiMigraceUcet[];
    idmigrace: string;
}

export interface ILeiRegistraceResp {
    varsym: string;
    id: number;
}

export interface ILeiMigraceResp {
    stav: ELeiMigraceStav;
}

export const leiMigraceApi = (idmigrace: string, token: string) => {
    return axios({
        method: 'POST',
        url: '/LEI/Migrace',
        headers: {
            Authorization: `Bearer ${token}`
        },
        data: {
            idmigrace: idmigrace
        }
    });
};

export const leiMigraceObnoveniApi = (data: { lei: string; email: string }) => {
    return axios({
        method: 'POST',
        url: 'LEI/Migrace/obnoveni',
        data: data
    });
};

export const leiMigracePasswordApi = (data: { initcode: string; heslo: string }) => {
    return axios({
        method: 'POST',
        url: 'LEI/Migrace/password',
        data: data
    }).then(resp => resp.status);
};
